module.exports = __webpack_public_path__ + "static/media/imageChoice.4195ffaf.svg";